import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-85" data-mp="26k9wuh2e19bf">
      <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="22lkcg4ixmria">
        <SectionHeading title="What Could Change With a More Structured Communication Support System?" data-id="element-87" data-mp="22iockanixsr7" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-88" data-mp="2z8xkgjam0as5">
          <div className="flex flex-col rounded-3xl border-2 border-coral/25 bg-white p-5 sm:p-7" data-id="element-89" data-mp="2ud03qbvfp2eu">
            <div className="rounded-2xl bg-coral px-4 py-3 text-center" data-id="element-90" data-mp="2q9ah3rybkuwg">
              <p className="text-2xl font-black uppercase tracking-wide text-white" data-id="element-91" data-mp="2lbsai87ryrrm">Before</p>
            </div>
            <h3 className="mt-5 text-center text-xl font-black leading-snug text-navy" data-id="element-92" data-mp="1evgheljt802w">
              Scattered Resources. Unclear Next Steps.
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-93" data-mp="19ygc4cusb1cu">
              {beforeItems.map(item => <li key={item} className="flex gap-3 rounded-xl bg-coral-soft p-3.5" data-id="element-94" data-mp="1739qv3h0hs6y">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-coral text-white" data-id="element-95" data-mp="1c3nvebjemk08">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="y70rfot1atkt" />
                  </span>
                  <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-97" data-mp="oeuz2dyvea53">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl border-2 border-cta/30 bg-white p-5 sm:p-7" data-id="element-98" data-mp="t7605k5ck1z8">
            <div className="rounded-2xl bg-cta px-4 py-3 text-center" data-id="element-99" data-mp="ffrawvkuj4jq">
              <p className="text-2xl font-black uppercase tracking-wide text-white" data-id="element-100" data-mp="jgtf7qtme6sk">After</p>
            </div>
            <h3 className="mt-5 text-center text-xl font-black leading-snug text-navy" data-id="element-101" data-mp="5hbmj0d7e9dx">
              Organized Resources. Clearer Planning. More Practical Support.
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-102" data-mp="2c4iyg55l2ymh">
              {afterItems.map(item => <li key={item} className="flex gap-3 rounded-xl bg-leaf-soft p-3.5" data-id="element-103" data-mp="27d0x3fznew0z">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-104" data-mp="23bpgu12nzn5g">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-105" data-mp="1ydnnmnbiy7g9" />
                  </span>
                  <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-106" data-mp="2v23qtm7k4fbu">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy p-6 text-center sm:p-8" data-id="element-107" data-mp="2m1xg2838ttgd">
          <p className="text-2xl font-black text-sun" data-id="element-108" data-mp="2h3m49rte18vi">The Difference?</p>
          <p className="mt-3 text-lg font-semibold leading-relaxed text-white" data-id="element-109" data-mp="2h5gjqqlw48s7">
            You move from scattered materials and disconnected planning tasks toward a more organized,
            individualized approach to communication support.
          </p>
          <p className="mt-3 text-base font-semibold leading-relaxed text-white/75" data-id="element-110" data-mp="vlbhp82zdwon">
            Not a rigid formula. Not a promise of identical outcomes for every child. A practical educational
            reference you can adapt to different communication profiles and environments.
          </p>
        </div>

        <div className="mt-10" data-id="element-111" data-mp="1aapp4amzy41e">
          <CtaButton label="I want a more structured approach" sub="Instant Digital Access · Just $27" data-id="element-112" data-mp="1aazj09b5wvcd" />
        </div>
      </div>
    </section>;
}